import { CartLinesUpdateEvent } from '@shopify/events';

// Use Horizon's native lifecycle so the count, drawer and cart sections stay in sync.
document.addEventListener('ux:cart-added', (event) => {
  const { items, sections } = event.detail;
  const deferred = CartLinesUpdateEvent.createPromise();
  event.target.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: items.map(item => ({ merchandiseId: String(item.id), quantity: item.quantity })),
    promise: deferred.promise,
  }));
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(response => { if (!response.ok) throw new Error('Cart refresh'); return response.json(); })
    .then(cart => deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { source: 'lhx-fbt', items: cart.items, itemCount: cart.item_count, sections, didError: false },
    }))
    .catch(error => { deferred.reject(error); console.warn('[UnionX FBT] Cart refresh failed', error); });
});
